// extracted by mini-css-extract-plugin
module.exports = {"Switch":"Switch_Switch__L6I0g","switcher":"Switch_switcher__drESc","dot":"Switch_dot__hi1bL","tick":"Switch_tick__ayqS6"};